// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
  font-family: "Clans Pro", sans-serif;
  text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  -webkit-font-smoothing: antialiased;
}

input,
button,
textarea,
select {
  font: inherit;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

#root,
#__next {
  isolation: isolate;
}

a {
  text-decoration: none;
  color: black;
}

button {
  cursor: pointer;
  outline: none;
}

.btn_solid_bg {
  border: 1px solid #333333;
  background: #333333;
  color: #000;
  color: #fff;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 10px;
  padding: 9.5px 14px;
  font-size: 18px;
  font-weight: 500;
  position: relative;
}
.btn_solid_bg.grey {
  color: #333333;
  background: #f2f2f2;
  border: 1px solid #f2f2f2;
}
.btn_solid_bg.grey_inverted {
  color: #000;
  background: #fff;
  border: 1px solid #bdbdbd;
}

.btn.outline {
  border: 1px solid #4f4f4f;
}

.btn_solid_bg_inverted {
  border: 1px solid #333333;
  color: #333333;
  background: transparent;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 9.5px 14px;
  font-size: 18px;
  font-weight: 500;
}

.ui.disabled.dropdown,
.ui.dropdown .menu > .disabled.item {
  background: #f2f2f2 !important;
  border: 1px solid #bdbdbd;
}

.ui.form .field .ui.disabled.dropdown .text {
  color: #828282;
}

.ui.inverted.form .label {
  color: #000 !important;
  font-weight: 500;
}

.ui.items:last-child {
  margin: 0px;
}

.text-error {
  color: rgb(201, 15, 15);
  font-size: 12px;
}

.form-control:focus {
  color: #212529;
  background-color: #fff;
  border-color: rgb(58, 57, 57);
  outline: 0;
  box-shadow: none;
}

.text-small {
  font-size: 10px;
}

.filterSearch {
  background: #f1f1f1;
  width: 255px !important;
}

.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  width: 2.375rem;
  height: -0.625rem;
  line-height: 2.4rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}

.bidRequestId {
  font-size: 10px;
}

.action-btn {
  border: 1px solid black;
}

.action-btn:hover {
  border: 1px solid black;
  background-color: #333333;
}

.top-panel {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  padding: 15px;
}

.page-title {
  font-size: 16px;
  font-weight: 450;
}

.add-driver-form {
  width: 95%;
  padding: 20px;
}

.add-bank-form {
  width: 95%;
  padding: 20px;
}

label {
  font-weight: bold;
  font-size: 13px;
}

.col-gap-20 {
  column-gap: 20px;
}

.col-gap-10 {
  column-gap: 10px;
}

select.form-control {
  -webkit-appearance: menulist;
}

.add-driver-form .form-control {
  padding: 10px;
}

.add-bank-form .form-control {
  padding: 10px;
}

.theme-btn {
  background-color: #bfe635;
  background-color: #333333;
  color: black;
  color: #fff;
}

.theme-btn:focus {
  background-color: #333333;
  border-color: #333333;
  color: black;
  color: #fff;
}

.theme-btn:disabled {
  background-color: #333333;
  border-color: #333333;
  color: black;
  color: #fff;
}

.theme-btn:hover {
  background-color: #c9f03e;
  background-color: #333333;
  color: black;
  color: #fff;
  border-color: #333333;
}

.upload-bol-btn {
  margin-right: 14px;
}

.dialogue {
  position: fixed;
  z-index: 1;
  top: 64px;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.301);
}

.dialogue-content {
  min-width: 100%;
}

.dialogue-form {
  position: fixed;
  padding: 30px;
  background-color: #fff;
  width: 390px;
  left: 53%;
  top: 28%;
  box-shadow: 1px 1px 10px 4px rgba(59, 55, 55, 0.493);
}

.dialogue-title {
  font-weight: 500;
  font-size: 20px;
}

.dialogue .form-control {
  padding: 10px;
}

.dialogue-close {
  font-size: 16px;
  cursor: pointer;
}

.success-dialogue-form {
  position: fixed;
  padding: 30px;
  background-color: #d4fb41;
  width: 390px;
  left: 51%;
  top: 38%;
  box-shadow: 1px 1px 10px 4px rgba(59, 55, 55, 0.493);
}

.cursor-pointer {
  cursor: pointer;
}

.auth-form .text-error {
  color: rgb(243, 124, 124);
}

.otpbox {
  font-size: 30px;
  justify-content: center !important;
}

.otpbox input {
  margin: 8px;
}

.payment_info {
  width: 450px;
  justify-content: center;
  margin: 0 auto;
}

.ui.radio label {
  cursor: auto;
  position: relative;
  padding-left: 10px;
  outline: 0;
  font-size: 1em;
}

.location-component {
  padding: 17px 20px;
  border: 1px solid lightgrey;
  border-radius: 5px;
}
.location-component .title {
  font-weight: 500;
}
.location-component p {
  margin: 0;
}
.location-component .detail {
  margin-top: 9px;
}

.btn_solid_bg:hover {
  background-color: #333333;
  color: black;
  color: #fff;
}

.forget-password-otp input {
  width: 20px !important;
}

.pass-eye-icon {
  float: right;
  margin-right: 8px;
  font-size: 18px;
  margin-top: -30px;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

.action-icon {
  column-gap: 10px;
  font-size: 15px;
}

.main-logo {
  height: 30px;
  column-gap: 14px;
}

.company-name {
  color: grey;
  font-size: 20px;
  margin-top: auto;
}

.track-order {
  padding: 20px 40px 0 20px;
}

.forgot-password-otp input {
  color: #000 !important;
  padding: 0 !important;
}

.forgot-password-otp {
  font-size: 35px;
  justify-content: center !important;
}

.forgot-password-otp input {
  margin-right: 25px;
}

.bol .nav-link {
  color: gray;
  font-size: 16px;
}

.bol .nav-link.active {
  color: black;
  font-weight: 500;
}

.bol-action-icon {
  margin-right: 8px;
}

.account-settings .account-settings-menu {
  padding-left: 30px;
}
.account-settings h3 {
  padding: 18px 30px 2px 30px;
}
.account-settings .menu-item {
  padding: 18px 18px 18px 0;
}
.account-settings .menu-title {
  font-size: 16px;
}

.sweet-loading {
  position: fixed;
  color: black;
  z-index: 10000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(43, 34, 34, 0.3215686275);
  justify-content: center;
}

.order-confirmed-label {
  width: 4px;
  position: absolute;
  left: -1px;
  top: 0;
  height: 100%;
  background: #3cb931;
}

.new-bid-request-label {
  width: 4px;
  position: absolute;
  left: -1px;
  top: 0;
  height: 100%;
  background: #2248c5;
}

.bid-awarded-label {
  width: 4px;
  position: absolute;
  left: -1px;
  top: 0;
  height: 100%;
  background: #c3f157;
}

.other-label {
  width: 4px;
  position: absolute;
  left: -1px;
  top: 0;
  height: 100%;
  background: rgb(187, 182, 182);
}

.notification-action-icon {
  font-size: 18px;
}

.notification-action-icon .fa:hover {
  text-shadow: 0px 2px 10px rgb(179, 176, 176);
}

.additional_links .active {
  border-bottom: 2px solid #c3f157;
  padding-bottom: 3px;
}

.invite-code-info {
  margin: 30px;
}
.invite-code-info .invite-code-block {
  padding: 30px;
  background-color: rgb(235, 235, 235);
}
.invite-code-info .title {
  font-size: 18px;
}
.invite-code-info .invite-code {
  font-size: 20px;
  font-weight: 500;
}
.invite-code-info .invite-code-form {
  margin-top: 20px;
}

.theme-text {
  color: #d4fb41;
}

.password_eye_icon {
  position: absolute;
  top: 0;
  right: 5px;
  line-height: 1.15;
  margin: inherit;
  cursor: pointer;
}

.ui.loading.button {
  display: none;
}

.btn_solid_bg .signin {
  display: inline-block !important;
  background: transparent !important;
  text-align: right;
  position: absolute !important;
  right: 0;
}

.signin_form {
  width: 340px;
  margin-top: 100px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
}
.signin_form .description {
  font-weight: 400;
  font-size: 32px;
  line-height: 51px;
  color: #ffffff;
  margin-bottom: 20px;
  text-wrap: balance;
}
.signin_form .btn_wrapper {
  display: flex;
  flex-direction: column;
}
.signin_form .text-error {
  color: rgb(255, 97, 97) !important;
}

.signin_form .heading {
  font-weight: 500;
  font-size: 32px;
  line-height: 41px;
  color: #ffffff;
  margin-bottom: 30px;
}
.signin_form .heading_m {
  font-weight: 500;
  font-size: 22px;
  line-height: 28px;
  color: #ffffff;
  margin-bottom: 10px;
}
.signin_form .heading_s {
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  color: #ffffff;
  margin-bottom: 10px;
}
.signin_form .input_wrapper label {
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
.signin_form .input_wrapper .input {
  flex-direction: column;
  width: 100%;
  margin-bottom: 14px;
  margin-top: 10px;
}
.signin_form input {
  padding: 9.5px 14px !important;
}
.signin_form .forgot_password {
  font-weight: 500;
  font-size: 18px;
  text-align: right;
  color: #ffffff;
}
.signin_form button {
  margin: 20px 0;
}

input[type=text],
input[type=password],
input[type=password],
input[type=select],
option {
  text-transform: none;
}

.ui.inverted.segment,
.ui.primary.inverted.segment {
  background: transparent !important;
}

.card {
  background: #fff;
  transition: 0.5s;
  border: 0;
  margin-bottom: 30px;
  border-radius: 0.55rem;
  position: relative;
  width: 100%;
}

.chat-app .people-list {
  width: 280px;
  position: absolute;
  left: 0;
  top: 0;
  padding: 20px;
  z-index: 7;
}

.people-list {
  transition: 0.5s;
}

.people-list .chat-list li {
  padding: 10px 15px;
  list-style: none;
  border-radius: 3px;
}

.people-list .chat-list li:hover {
  background: #efefef;
  cursor: pointer;
}

.people-list .chat-list li.active {
  background: #efefef;
}

.people-list .chat-list li .name {
  font-size: 15px;
}

.people-list .chat-list img {
  width: 45px;
  border-radius: 50%;
}

.people-list img {
  float: left;
  border-radius: 50%;
}

.people-list .about {
  float: left;
  padding-left: 8px;
}

.people-list .status {
  color: #999;
  font-size: 13px;
}

.chat .chat-header {
  padding: 15px 20px;
  border-bottom: 2px solid #f4f7f6;
}

.chat .chat-header img {
  float: left;
  border-radius: 40px;
  width: 40px;
}

.chat .chat-header .chat-about {
  float: left;
  padding-left: 10px;
}

.chat .chat-history {
  padding: 20px;
  border-bottom: 2px solid #fff;
}

.chat .chat-history ul {
  padding: 0;
}

.chat .chat-history ul li {
  list-style: none;
  margin-bottom: 15px;
}

.chat .chat-history ul li:last-child {
  margin-bottom: 0px;
}

.chat .chat-history .message-data {
  margin-bottom: 8px;
}

.chat .chat-history .message-data img {
  border-radius: 40px;
  width: 40px;
}

.chat .chat-history .message-data-time {
  color: #434651;
  padding-left: 6px;
  font-size: 10px;
}

.chat .chat-history .message {
  color: #444;
  padding: 10px 12px;
  line-height: 26px;
  border-radius: 7px;
  display: inline-block;
  position: relative;
  max-width: 60%;
}

.chat .chat-history .message:after {
  bottom: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: #fff;
  border-width: 10px;
  margin-left: -10px;
}

.chat .chat-history .my-message {
  background: #efefef;
}

.chat .chat-history .my-message:after {
  bottom: 100%;
  left: 25px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: #efefef;
  border-width: 10px;
}

.chat .chat-history .other-message {
  background: #e8f1f3;
  text-align: right;
}

.chat .chat-history .other-message:after {
  border-bottom-color: #e8f1f3;
  right: 10px;
}

.chat .chat-message {
  padding: 20px;
}

.online,
.offline,
.me {
  margin-right: 2px;
  font-size: 8px;
  vertical-align: middle;
}

.online {
  color: #86c541;
}

.offline {
  color: #e47297;
}

.me {
  color: #1d8ecd;
}

.float-right {
  float: right;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

@media only screen and (max-width: 767px) {
  .chat-app .people-list {
    height: 465px;
    width: 100%;
    overflow-x: auto;
    background: #fff;
    left: -400px;
    display: none;
  }
  .chat-app .people-list.open {
    left: 0;
  }
  .chat-app .chat {
    margin: 0;
  }
  .chat-app .chat .chat-header {
    border-radius: 0.55rem 0.55rem 0 0;
  }
  .chat-app .chat-history {
    height: 300px;
    overflow-x: auto;
  }
}
.chat-app .chat-list {
  height: 480px;
  overflow-x: auto;
}

.chat-app .chat-history {
  height: 380px;
  overflow-x: auto;
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .chat-app .chat-list {
    height: 480px;
    overflow-x: auto;
  }
  .chat-app .chat-history {
    height: 600px;
    overflow-x: auto;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
  .chat-app .chat-list {
    height: 480px;
    overflow-x: auto;
  }
  .chat-app .chat-history {
    height: calc(100vh - 350px);
    overflow-x: auto;
  }
}
.fa-send {
  height: 21px;
}

.password_eye_icon_signup {
  position: absolute;
  top: 0;
  right: 5px;
  line-height: 1.15;
  margin: auto;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
}

.ui.loading.button {
  display: none;
}

.btn_solid_bg .signin {
  display: inline-block !important;
  background: transparent !important;
  text-align: right;
  position: absolute !important;
  right: 0;
}

.signup_form {
  width: 340px;
  margin-top: 30px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
}
.signup_form .description {
  font-weight: 400;
  font-size: 32px;
  line-height: 51px;
  color: #ffffff;
  margin-bottom: 20px;
  text-wrap: balance;
}
.signup_form .btn_wrapper {
  display: flex;
  flex-direction: column;
}
.signup_form .heading {
  font-weight: 500;
  font-size: 32px;
  line-height: 41px;
  color: #ffffff;
  margin-bottom: 30px;
}
.signup_form .heading_m {
  font-weight: 500;
  font-size: 22px;
  line-height: 28px;
  color: #ffffff;
  margin-bottom: 10px;
}
.signup_form .heading_s {
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  color: #ffffff;
  margin-bottom: 10px;
}
.signup_form .input_wrapper label {
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
.signup_form .input_wrapper .input {
  flex-direction: column;
  width: 100%;
  margin-bottom: 14px;
  margin-top: 10px;
}
.signup_form input {
  padding: 9.5px 14px !important;
}
.signup_form .forgot_password {
  font-weight: 500;
  font-size: 18px;
  text-align: right;
  color: #ffffff;
}
.signup_form button {
  margin: 20px 0;
}
.signup_form .heading {
  margin-bottom: 10px;
}
.signup_form {
  width: 700px;
}

.form_info {
  font-weight: 400;
  font-size: 15px;
  text-align: justify;
  color: #d4fb41;
}
.form_info span {
  text-decoration: underline;
}

.pdf {
  height: inherit;
}

@keyframes slideUp {
  from {
    transform: translateY(100vh);
  }
  to {
    transform: translateY(0);
  }
}
.bubbleContainer {
  width: 80%;
  display: flex;
  padding: 10px 20px;
  animation: slideUp 0.5s ease-in-out;
}

.close {
  font-size: 16px;
}

.google-map {
  height: 400px;
}
.google-map .google-map-marker {
  color: rgb(184, 184, 184);
  font-size: 40px;
  position: relative;
  bottom: 38px;
  right: 10px;
}

.auto-pricing .row > *,
.freight-charges .row > * {
  padding-left: 0 !important;
}
.auto-pricing .form-control,
.freight-charges .form-control {
  height: 42px;
  font-size: 13px;
  cursor: pointer;
}
.auto-pricing .title,
.freight-charges .title {
  font-size: 14px;
  font-weight: 500;
}
.auto-pricing .add-icon,
.freight-charges .add-icon {
  height: 42px;
  display: flex;
  cursor: pointer;
}
.auto-pricing .add-icon i,
.freight-charges .add-icon i {
  font-size: 30px;
  align-self: flex-end;
}
.auto-pricing .price-action-btn,
.freight-charges .price-action-btn {
  min-height: 42px;
  min-width: 42px;
}
.auto-pricing .price-rows,
.freight-charges .price-rows {
  min-height: 50vh;
}
.auto-pricing .not-available,
.freight-charges .not-available {
  height: 42px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bg-grey {
  background-color: #f3f3f3;
}

.driver-details {
  background-color: rgb(228, 228, 228);
  border-radius: 5px;
  padding: 24px 0;
  margin: 0 20px;
}

.bold {
  font-weight: 500;
}

.sc-hLBbgP {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.sc-eDWCr {
  text-overflow: unset !important;
}

.lnndaO {
  white-space: pre-line !important;
}

.text-theme {
  color: #b8df2c;
}

.bg-pending {
  background-color: #f2c94c;
  color: black;
}

.badge {
  padding: 5px;
  letter-spacing: 2px;
}

.ls-1 {
  letter-spacing: 1px;
}

.text-green {
  color: #21611c;
}

.btn-danger {
  background-color: rgba(190, 33, 33, 0.87);
}

.btn-secondary {
  color: #000;
  background-color: rgb(231, 231, 231);
  border-color: rgb(192, 192, 192);
}

.btn-secondary:hover {
  color: #000;
  background-color: rgb(206, 206, 206);
  border-color: rgb(192, 192, 192);
}

.notification-icon .badge {
  position: relative;
  top: -10px;
  left: -14px;
  font-size: 9px;
  letter-spacing: 0;
}
.notification-icon i {
  font-size: 20px !important;
}

.auth .modal {
  background-color: rgba(92, 92, 92, 0.123);
}
.auth .modal-content {
  padding: 30px;
  background-color: #daff56;
  border: 1px solid lightgrey;
  box-shadow: 1px 1px 10px 4px rgba(59, 55, 55, 0.363);
}

.otpbox input {
  padding: 0 !important;
}

.dwolla-main .dwolla-submit input[type=submit] {
  border: 0;
  cursor: pointer;
  display: inline-block;
  width: 120px;
  margin-top: 10px;
  margin-bottom: 0px;
  padding: 10px 20px;
  border-radius: 3px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  background-color: #202033;
  box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.1), inset 0px 1px 0px 1px rgba(255, 255, 255, 0.06);
}
.dwolla-main .dwolla-customer-input {
  border: 1px solid #c9d3e0;
  cursor: pointer;
  display: inline-block;
  transition: box-shadow 0.5s, background-color 0.5s, border 0.5s;
  border-radius: 3px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  text-decoration: none;
  background-color: #fff;
  color: #5e4e76;
}
.dwolla-main .dwolla-width-1 {
  width: 470px;
}
.dwolla-main .dwolla-width-1 input[type=text] {
  padding: 10px 0px 10px 15px;
  width: 455px;
}
.dwolla-main .dwolla-width-2 {
  width: 228px;
}
.dwolla-main .dwolla-width-2 input[type=text] {
  padding: 10px 0px 10px 15px;
  width: 213px;
}
.dwolla-main .dwolla-width-3 {
  width: 147px;
}
.dwolla-main .dwolla-width-3 input[type=text] {
  padding: 10px 0px 10px 15px;
  width: 133px;
}
.dwolla-main ::placeholder {
  color: #52627b;
  opacity: 1;
}
.dwolla-main :-ms-input-placeholder {
  color: #52627b;
}
.dwolla-main ::-ms-input-placeholder {
  color: #52627b;
}
.dwolla-main .dwolla-customer-input[type=text]:disabled {
  background: #dddddd;
  cursor: default;
}
.dwolla-main #dwolla-success {
  background-color: #ddf0e0;
  color: #354153;
  text-align: center;
  padding: 10px;
  border-radius: 3px;
  border-color: #58b467;
  border-style: solid;
  border-width: 1px;
}
.dwolla-main #dwolla-info {
  background: rgba(54, 136, 207, 0.15);
  color: #354153;
  text-align: center;
  padding: 10px;
  border-radius: 3px;
  border: 1px solid rgba(54, 136, 207, 0.5);
}
.dwolla-main #dwolla-error {
  background-color: #f7ebee;
  color: #354153;
  text-align: center;
  padding: 10px;
  border-radius: 3px;
  border-color: #cf5473;
  border-style: solid;
  border-width: 1px;
}
.dwolla-main .dwolla-link {
  color: #1d6cd1;
}
.dwolla-main .dwolla-customer-tos {
  width: 100%;
  height: 80px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  margin-top: 20px;
}
.dwolla-main .dwolla-customer-checkbox {
  width: 5%;
  height: 80px;
  display: inline;
  float: left;
}
.dwolla-main .dwolla-customer-text {
  width: 91%;
  height: 80px;
  display: inline;
  float: left;
  margin-left: 10px;
}
.dwolla-main .dwolla-input-container {
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  padding: 0px 0px;
}
.dwolla-main .dwolla-input-container label {
  text-align: left;
  display: block;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
}
.dwolla-main .dwolla-loading {
  background-color: #5e4e76;
  position: relative;
  animation-name: loading;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}
@keyframes loading {
  0% {
    background-color: #5e4e76;
  }
  50% {
    background-color: #8393aa;
  }
  100% {
    background-color: #5e4e76;
  }
}
.dwolla-main .dwolla-document-submit input[type=submit] {
  border: 0;
  cursor: pointer;
  display: inline-block;
  width: 120px;
  margin-top: 45px;
  margin-bottom: 0px;
  padding: 10px 20px;
  transition: box-shadow 0.5s, background-color 0.5s, border 0.5s;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  background-color: #5e4e76;
}
.dwolla-main .dwolla-submit input[type=submit] {
  border: 0;
  cursor: pointer;
  display: inline-block;
  width: 120px;
  margin-top: 10px;
  margin-bottom: 0px;
  padding: 10px 20px;
  transition: box-shadow 0.5s, background-color 0.5s, border 0.5s;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  background-color: #5e4e76;
}
.dwolla-main .dwolla-document-choose input[type=file] {
  display: none;
}
.dwolla-main .dwolla-document-type {
  border: 0;
  float: left;
  margin-top: 5px;
  margin-bottom: 0px;
  padding: 10px 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
.dwolla-main .dwolla-document-type select {
  border: 0;
  cursor: pointer;
  float: left;
  margin-top: 5px;
  margin-bottom: 0px;
  padding: 10px 20px;
  transition: box-shadow 0.5s, background-color 0.5s, border 0.5s;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  color: #5e4e76;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(53, 65, 83, 0.12), 0 0 2px 0 rgba(53, 65, 83, 0.12);
}
.dwolla-main .dwolla-document-type label {
  border: 0;
  cursor: pointer;
  float: left;
  margin-top: 5px;
  margin-bottom: 0px;
  font-size: 12px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #5e4e76;
}
.dwolla-main .dwolla-document-name-display {
  text-align: center;
  padding: 5px;
  border: 1px solid #c9d3e0;
  width: 314px;
  cursor: pointer;
  display: inline-block;
  margin-top: 25px;
  margin-bottom: 0px;
  margin-right: 0px;
  padding: 10px 20px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #354153;
  background-color: #fff;
  box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.05);
}
.dwolla-main .hide-class {
  display: none;
}
.dwolla-main .dwolla-span-container {
  display: inline-block;
  width: 320px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  padding: 0px 0px;
}
.dwolla-main .dwolla-span-container label {
  text-align: center;
  display: block;
  font-size: 10px;
}
.dwolla-main .dwolla-document-submit input[type=submit] {
  border: 0;
  cursor: pointer;
  display: inline-block;
  width: 470px;
  margin-top: 20px;
  margin-bottom: 0px;
  padding: 10px 20px;
  background: #202033;
  box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.1), inset 0px 1px 0px 1px rgba(255, 255, 255, 0.06);
  border-radius: 3px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  text-decoration: none;
  color: #fff;
}
.dwolla-main .dwolla-submit input[type=submit] {
  border: 0;
  cursor: pointer;
  display: inline-block;
  width: 470px;
  margin-top: 20px;
  margin-bottom: 0px;
  padding: 10px 20px;
  background: #202033;
  box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.1), inset 0px 1px 0px 1px rgba(255, 255, 255, 0.06);
  border-radius: 3px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  text-decoration: none;
  color: #fff;
}
.dwolla-main .dwolla-document-choose input[type=file] {
  display: none;
}
.dwolla-main .dwolla-file-name {
  margin-top: 10px;
  margin-bottom: 0px;
  height: 40px;
  width: 470px;
}
.dwolla-main .dwolla-document-label {
  text-align: left;
  display: inline-block;
  width: 470px;
}
.dwolla-main .dwolla-document-chooser {
  cursor: pointer;
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 0px;
  margin-left: -5px;
  padding: 10px 20px;
  box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.05);
  border-radius: 3px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  text-decoration: none;
  color: #354153;
  background: rgba(201, 211, 224, 0.6);
  border: 1px solid #c9d3e0;
}
.dwolla-main .dwolla-document-type {
  border: 0;
  float: left;
  margin-top: 5px;
  margin-bottom: 20px;
  padding: 10px 0px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
}
.dwolla-main .dwolla-document-type select {
  border: 1px solid #c9d3e0;
  width: 470px;
  cursor: pointer;
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 0px;
  padding: 10px 20px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #354153;
  background-color: #fff;
  box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.05);
}
.dwolla-main .dwolla-document-type option {
  font-weight: 400;
}
.dwolla-main .dwolla-document-description {
  color: #52627b;
  text-align: left;
  padding: 5px 0px;
}

@media screen and (max-width: 850px) {
  .sidebar_container {
    display: none;
  }
  .dashboard_rightcontainer {
    min-width: 100%;
  }
}
.dwolla-vcr-submit {
  background-color: #bfe635 !important;
  color: black;
}

.dwolla-vcr-submit:disabled {
  background-color: #d4fb41 !important;
  border-color: #d4fb41 !important;
  color: black !important;
}

.dwolla-content {
  display: flex !important;
  justify-content: center !important;
  border: 1px solid lightgrey;
  padding: 10px;
  width: 99%;
  background-color: #fafafa;
  border-radius: 5px;
}

.card {
  margin: 10px;
  border: 1px solid lightgrey;
  height: 100%;
  box-shadow: 1px 1px 3px 1px lightgrey;
}

.width_box_lg {
  width: 700px;
  min-height: 100vh;
  margin: 0 auto;
}

.width_box_sm {
  width: 340px;
  height: 100vh;
  width: 400px;
  display: flex;
  flex-direction: column;
  margin: 0 auto 0 auto;
}

.form-check-input:checked {
  background-color: #a4c52e !important;
  border-color: #a4c52e !important;
  border: 1px solid grey !important;
}

.form-check-input {
  border: 1px solid grey !important;
}

.table-action-icon {
  font-size: 20px;
  cursor: pointer;
}

.custom-scroll {
  scroll-behavior: smooth;
  height: 100%;
}

.taxesAndSurchargestext {
  cursor: pointer;
  position: absolute;
  transform: translate(72px, -24px);
  height: 14px;
  width: 110px;
}
.taxesAndSurchargestext.left {
  transform: translate(40px, 0px);
}

.taxesAndSurchargesTooltip {
  position: relative;
  text-align: center;
  background-color: #fff;
  visibility: hidden;
  transform: translate(-460px, -270px);
  width: 590px;
  z-index: 100;
  overflow-y: auto;
  border-radius: 8px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  height: 250px;
}
.taxesAndSurchargesTooltip .taxChargesView > :last-child > sub {
  bottom: 0.05rem;
}

.taxesAndSurchargestext:hover .taxesAndSurchargesTooltip {
  visibility: visible;
}

div#date-picker-container > div {
  width: 100%;
}

.text-wrap-ellipsis {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

.text-first-letter-uppercase {
  text-transform: lowercase;
}
.text-first-letter-uppercase::first-letter {
  text-transform: uppercase;
}

.outline1 {
  outline: 1px solid red;
}

.active_td {
  width: 0.625rem;
  position: absolute;
  left: -1px;
  top: 0;
  height: 100%;
  background: #d4fb41;
}

.text-transform-none {
  text-transform: none !important;
}

.feedback-direct {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  text-decoration: underline;
  transition: text-decoration 0.3s ease;
  display: flex;
  align-items: center;
}
.feedback-direct:hover {
  color: inherit;
  text-decoration: none;
}
.feedback-direct:hover:has(> svg) > svg {
  fill: #d4fb41;
  height: 20px;
}
.feedback-direct:has(> svg) > svg {
  translate: 0 -10%;
  fill: #000;
  height: 20px;
}

.text-end-center {
  display: flex;
  align-items: center;
  justify-content: end;
}

/* Accessibility classes*/
i.flag:not(.icon),
i.icon,
.ui.accordion .accordion .title .dropdown.icon,
.ui.accordion .title .dropdown.icon,
.ui.checkbox,
.ui.selection.dropdown .menu,
.ui.search.dropdown .menu,
.ui.scrolling.dropdown .menu,
.ui.dropdown > .dropdown.icon,
.ui.visible.popup,
.ui.rating .icon,
.ui.shape .side,
.ui.shape .side *,
.ui.sidebar,
.ui.sidebar > *,
.pushable > .fixed,
.pushable > .pusher,
.animating.transition {
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.ui.justified.container,
.ui.grid > .justified.column.column,
.ui.grid > .justified.row > .column,
.ui.grid > .row > .justified.column.column,
.ui.justified.grid > .column,
.ui.justified.grid > .row > .column {
  hyphens: auto;
}

.ui.selection.dropdown .menu {
  -webkit-overflow-scrolling: touch;
  -webkit-overflow-scrolling: touch;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AACA;;;EAGC,sBAAA;AAAD;;AAGA;EACC,SAAA;EACA,UAAA;EACA,oCAAA;EAEA,sBAAA;EACA,8BAAA;AAAD;;AAGA;;;EAGC,YAAA;EACA,SAAA;EACA,UAAA;AAAD;;AAGA;EACC,mCAAA;AAAD;;AAGA;;;;EAIC,aAAA;AAAD;;AAGA;;;;;;;EAOC,yBAAA;AAAD;;AAOA;;EAEC,kBAAA;AAJD;;AAOA;EACC,qBAAA;EACA,YAAA;AAJD;;AAOA;EACC,eAAA;EACA,aAAA;AAJD;;AAOA;EACC,yBAAA;EACA,mBApBe;EAqBf,WAAA;EACA,WArBc;EAsBd,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAJD;AAMC;EACC,cAAA;EACA,mBAAA;EACA,yBAAA;AAJF;AAOC;EACC,WAAA;EACA,gBAAA;EACA,yBAAA;AALF;;AASA;EACC,yBAAA;AAND;;AASA;EACC,yBAAA;EACA,cAlDe;EAmDf,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAND;;AASA;;EAEC,8BAAA;EACA,yBAAA;AAND;;AASA;EACC,cAAA;AAND;;AASA;EACC,sBAAA;EACA,gBAAA;AAND;;AASA;EACC,WAAA;AAND;;AASA;EACC,uBAAA;EACA,eAAA;AAND;;AASA;EACC,cAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;AAND;;AASA;EACC,eAAA;AAND;;AASA;EACC,mBAAA;EACA,uBAAA;AAND;;AASA;EACC,sBAAA;AAND;;AASA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;AAND;;AASA;EACC,eAAA;AAND;;AASA;EACC,uBAAA;AAND;;AASA;EACC,uBAAA;EACA,yBA5He;AAsHhB;;AASA;EAEC,2BAAA;EACA,8BAAA;EACA,aAAA;AAPD;;AAUA;EACC,eAAA;EACA,gBAAA;AAPD;;AAUA;EACC,UAAA;EACA,aAAA;AAPD;;AAUA;EACC,UAAA;EACA,aAAA;AAPD;;AAUA;EACC,iBAAA;EACA,eAAA;AAPD;;AAUA;EACC,gBAAA;AAPD;;AAUA;EACC,gBAAA;AAPD;;AAUA;EACC,4BAAA;AAPD;;AAaA;EACC,aAAA;AAVD;;AAaA;EACC,aAAA;AAVD;;AAaA;EACC,yBAAA;EACA,yBAnLe;EAoLf,YAAA;EACA,WApLc;AA0Kf;;AAaA;EACC,yBAzLe;EA0Lf,qBA1Le;EA2Lf,YAAA;EACA,WA3Lc;AAiLf;;AAaA;EACC,yBAhMe;EAiMf,qBAjMe;EAkMf,YAAA;EACA,WAlMc;AAwLf;;AAaA;EACC,yBAAA;EACA,yBAxMe;EAyMf,YAAA;EACA,WAzMc;EA0Md,qBA3Me;AAiMhB;;AAaA;EACC,kBAAA;AAVD;;AAcA;EACC,eAAA;EACA,UAAA;EACA,SAAA;EAEA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sCAAA;AAZD;;AAeA;EACC,eAAA;AAZD;;AAiBA;EACC,eAAA;EACA,aAAA;EACA,sBAtOc;EAuOd,YAAA;EACA,SAAA;EACA,QAAA;EACA,oDAAA;AAdD;;AAiBA;EACC,gBAAA;EACA,eAAA;AAdD;;AAiBA;EACC,aAAA;AAdD;;AAiBA;EACC,eAAA;EACA,eAAA;AAdD;;AAmBA;EACC,eAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,oDAAA;AAhBD;;AAmBA;EACC,eAAA;AAhBD;;AA0BA;EACC,yBAAA;AAvBD;;AA0BA;EACC,eAAA;EACA,kCAAA;AAvBD;;AA0BA;EACC,WAAA;AAvBD;;AA0BA;EACC,YAAA;EACA,uBAAA;EACA,cAAA;AAvBD;;AA0BA;EACC,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAvBD;;AA0BA;EACC,kBAAA;EACA,2BAAA;EACA,kBAAA;AAvBD;AAyBC;EACC,gBAAA;AAvBF;AA0BC;EACC,SAAA;AAxBF;AA2BC;EACC,eAAA;AAzBF;;AA6BA;EACC,yBAjUe;EAkUf,YAAA;EACA,WAlUc;AAwSf;;AA6BA;EACC,sBAAA;AA1BD;;AA6BA;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AA1BD;;AA6BA;EACC,gBAAA;EACA,eAAA;AA1BD;;AA6BA;EACC,YAAA;EACA,gBAAA;AA1BD;;AA6BA;EACC,WAAA;EACA,eAAA;EACA,gBAAA;AA1BD;;AA+BA;EACC,yBAAA;AA5BD;;AAiCA;EACC,sBAAA;EACA,qBAAA;AA9BD;;AAiCA;EACC,eAAA;EACA,kCAAA;AA9BD;;AAiCA;EACC,kBAAA;AA9BD;;AAiCA;EACC,WAAA;EACA,eAAA;AA9BD;;AAiCA;EACC,YAAA;EACA,gBAAA;AA9BD;;AAiCA;EACC,iBAAA;AA9BD;;AAkCC;EACC,kBAAA;AA/BF;AAkCC;EACC,2BAAA;AAhCF;AAmCC;EACC,yBAAA;AAjCF;AAoCC;EAEC,eAAA;AAnCF;;AAuCA;EACC,eAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gDAAA;EACA,uBAAA;AApCD;;AAuCA;EACC,UAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;AApCD;;AAuCA;EACC,UAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;AApCD;;AAuCA;EACC,UAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;AApCD;;AAuCA;EACC,UAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,8BAAA;AApCD;;AAuCA;EACC,eAAA;AApCD;;AAuCA;EACC,4CAAA;AApCD;;AAuCA;EACC,gCAAA;EACA,mBAAA;AApCD;;AAuCA;EACC,YAAA;AApCD;AAsCC;EACC,aAAA;EACA,oCAAA;AApCF;AAuCC;EACC,eAAA;AArCF;AAwCC;EACC,eAAA;EACA,gBAAA;AAtCF;AAyCC;EACC,gBAAA;AAvCF;;AAiDA;EACC,cAAA;AA9CD;;AAiDA;EACC,kBAAA;EACA,MAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AA9CD;;AAiDA;EACC,aAAA;AA9CD;;AAkDC;EACC,gCAAA;EACA,kCAAA;EACA,iBAAA;EACA,6BAAA;EACA,QAAA;AA/CF;;AAmDA;EACC,YAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AAhDD;AAkDC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAhDF;AAmDC;EACC,aAAA;EACA,sBAAA;AAjDF;AAoDC;EACC,kCAAA;AAlDF;;AAuDC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AApDF;AAuDC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AArDF;AAwDC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAtDF;AA0DE;EACC,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAxDH;AA2DE;EACC,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAzDH;AA6DC;EACC,8BAAA;AA3DF;AA8DC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA5DF;AA+DC;EACC,cAAA;AA7DF;;AAiEA;;;;;EAKC,oBAAA;AA9DD;;AAiEA;;EAEC,kCAAA;AA9DD;;AAiEA;EACC,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AA9DD;;AAkEA;EACC,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;AA/DD;;AAkEA;EAIC,gBAAA;AA/DD;;AAkEA;EACC,kBAAA;EACA,gBAAA;EACA,kBAAA;AA/DD;;AAkEA;EACC,mBAAA;EACA,eAAA;AA/DD;;AAkEA;EACC,mBAAA;AA/DD;;AAkEA;EACC,eAAA;AA/DD;;AAkEA;EACC,WAAA;EACA,kBAAA;AA/DD;;AAkEA;EACC,WAAA;EACA,kBAAA;AA/DD;;AAkEA;EACC,WAAA;EACA,iBAAA;AA/DD;;AAkEA;EACC,WAAA;EACA,eAAA;AA/DD;;AAkEA;EACC,kBAAA;EACA,gCAAA;AA/DD;;AAkEA;EACC,WAAA;EACA,mBAAA;EACA,WAAA;AA/DD;;AAkEA;EACC,WAAA;EACA,kBAAA;AA/DD;;AAkEA;EACC,aAAA;EACA,6BAAA;AA/DD;;AAmEA;EACC,UAAA;AAhED;;AAmEA;EACC,gBAAA;EACA,mBAAA;AAhED;;AAmEA;EACC,kBAAA;AAhED;;AAmEA;EACC,kBAAA;AAhED;;AAmEA;EACC,mBAAA;EACA,WAAA;AAhED;;AAmEA;EACC,cAAA;EACA,iBAAA;EACA,eAAA;AAhED;;AAmEA;EACC,WAAA;EACA,kBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAjED;;AAoEA;EACC,YAAA;EAEA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAlED;;AAqEA;EACC,mBAAA;AAlED;;AAqEA;EACC,YAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,kBAAA;AAlED;;AAsEA;EACC,mBAAA;EACA,iBAAA;AAnED;;AAsEA;EACC,4BAAA;EAEA,WAAA;AApED;;AAuEA;EACC,aAAA;AApED;;AAuEA;;;EAGC,iBAAA;EACA,cAAA;EACA,sBAAA;AApED;;AAuEA;EACC,cAAA;AApED;;AAuEA;EACC,cAAA;AApED;;AAuEA;EACC,cAAA;AApED;;AAuEA;EACC,YAAA;AApED;;AAuEA;EACC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AApED;;AAuEA;EACC;IACC,aAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,aAAA;EApEA;EAuED;IACC,OAAA;EArEA;EAwED;IACC,SAAA;EAtEA;EAyED;IACC,kCAAA;EAvEA;EA0ED;IACC,aAAA;IACA,gBAAA;EAxEA;AACF;AA2EA;EACC,aAAA;EACA,gBAAA;AAzED;;AA4EA;EACC,aAAA;EACA,gBAAA;AAzED;;AA4EA;EACC;IACC,aAAA;IACA,gBAAA;EAzEA;EA4ED;IACC,aAAA;IACA,gBAAA;EA1EA;AACF;AA6EA;EACC;IACC,aAAA;IACA,gBAAA;EA3EA;EA8ED;IACC,2BAAA;IACA,gBAAA;EA5EA;AACF;AA+EA;EACC,YAAA;AA7ED;;AAgFA;EACC,kBAAA;EACA,MAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA7ED;;AAgFA;EACC,aAAA;AA7ED;;AAiFC;EACC,gCAAA;EACA,kCAAA;EACA,iBAAA;EACA,6BAAA;EACA,QAAA;AA9EF;;AAkFA;EACC,YAAA;EAEA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AAhFD;AAkFC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAhFF;AAmFC;EACC,aAAA;EACA,sBAAA;AAjFF;AAoFC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAlFF;AAqFC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAnFF;AAsFC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AApFF;AAwFE;EACC,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAtFH;AAyFE;EACC,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAvFH;AA2FC;EACC,8BAAA;AAzFF;AA4FC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1FF;AA6FC;EACC,cAAA;AA3FF;AA8FC;EACC,mBAAA;AA5FF;AAaA;EAkFC,YAAA;AA5FD;;AA+FA;EACC,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AA5FD;AA8FC;EACC,0BAAA;AA5FF;;AAgGA;EACC,eAAA;AA7FD;;AAgGA;EACC;IACC,4BAAA;EA7FA;EAgGD;IACC,wBAAA;EA9FA;AACF;AAiGA;EACC,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mCAAA;AA/FD;;AAkGA;EACC,eAAA;AA/FD;;AAkGA;EACC,aAAA;AA/FD;AAiGC;EACC,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA/FF;;AAqGC;;EACC,0BAAA;AAjGF;AAoGC;;EACC,YAAA;EACA,eAAA;EACA,eAAA;AAjGF;AAoGC;;EACC,eAAA;EACA,gBAAA;AAjGF;AAoGC;;EACC,YAAA;EACA,aAAA;EACA,eAAA;AAjGF;AAoGC;;EACC,eAAA;EACA,oBAAA;AAjGF;AAoGC;;EACC,gBAAA;EACA,eAAA;AAjGF;AAoGC;;EACC,gBAAA;AAjGF;AAoGC;;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAjGF;;AAqGA;EACC,yBAAA;AAlGD;;AAqGA;EACC,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAlGD;;AAqGA;EACC,gBAAA;AAlGD;;AA0HA;EACC,6BAAA;EACA,8BAAA;AAvHD;;AA0HA;EACC,+BAAA;AAvHD;;AA0HA;EACC,gCAAA;AAvHD;;AA0HA;EACC,cAAA;AAvHD;;AA0HA;EACC,yBAAA;EACA,YAAA;AAvHD;;AA0HA;EACC,YAAA;EACA,mBAAA;AAvHD;;AA0HA;EACC,mBAAA;AAvHD;;AA0HA;EACC,cAAA;AAvHD;;AA0HA;EACC,yCAAA;AAvHD;;AA0HA;EACC,WAAA;EACA,oCAAA;EACA,gCAAA;AAvHD;;AA0HA;EACC,WAAA;EACA,oCAAA;EACA,gCAAA;AAvHD;;AA2HC;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EAEA,iBAAA;AAzHF;AA4HC;EACC,0BAAA;AA1HF;;AA+HC;EACC,yCAAA;AA5HF;AA+HC;EACC,aAAA;EACA,yBAAA;EACA,2BAAA;EACA,oDAAA;AA7HF;;AAsIA;EACC,qBAAA;AAnID;;AAuIC;EACC,SAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,yBAAA;EACA,8FAAA;AApIF;AAwIC;EACC,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,+DAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;AAtIF;AAyIC;EACC,YAAA;AAvIF;AA0IC;EACC,2BAAA;EACA,YAAA;AAxIF;AA2IC;EACC,YAAA;AAzIF;AA4IC;EACC,2BAAA;EACA,YAAA;AA1IF;AA6IC;EACC,YAAA;AA3IF;AA8IC;EACC,2BAAA;EACA,YAAA;AA5IF;AA+IC;EACC,cAAA;EACA,UAAA;AA7IF;AAgJC;EACC,cAAA;AA9IF;AAiJC;EACC,cAAA;AA/IF;AAkJC;EACC,mBAAA;EACA,eAAA;AAhJF;AAmJC;EACC,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAjJF;AAoJC;EACC,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;AAlJF;AAqJC;EACC,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAnJF;AAsJC;EACC,cAAA;AApJF;AAuJC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AArJF;AAwJC;EACC,SAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAtJF;AAyJC;EACC,UAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AAvJF;AA0JC;EACC,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAxJF;AA2JC;EACC,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAzJF;AA4JC;EACC,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mCAAA;AA1JF;AA6JC;EACC;IACC,yBAAA;EA3JD;EA8JA;IACC,yBAAA;EA5JD;EA+JA;IACC,yBAAA;EA7JD;AACF;AAgKC;EACC,SAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,+DAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,yBAAA;AA9JF;AAiKC;EACC,SAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,+DAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,yBAAA;AA/JF;AAkKC;EACC,aAAA;AAhKF;AAmKC;EACC,SAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAjKF;AAoKC;EACC,SAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,+DAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,gFAAA;AAlKF;AAsKC;EACC,SAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AApKF;AAuKC;EACC,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,8CAAA;AArKF;AAwKC;EACC,aAAA;AAtKF;AAyKC;EACC,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAvKF;AA0KC;EACC,kBAAA;EACA,cAAA;EACA,eAAA;AAxKF;AA2KC;EACC,SAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8FAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AA1KF;AA6KC;EACC,SAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8FAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AA5KF;AA+KC;EACC,aAAA;AA7KF;AAgLC;EACC,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AA9KF;AAiLC;EACC,gBAAA;EACA,qBAAA;EACA,YAAA;AA/KF;AAkLC;EACC,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,oCAAA;EACA,yBAAA;AAhLF;AAmLC;EACC,SAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAjLF;AAoLC;EACC,yBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,8CAAA;AAlLF;AAqLC;EACC,gBAAA;AAnLF;AAsLC;EACC,cAAA;EACA,gBAAA;EACA,gBAAA;AApLF;;AAwLA;EACC;IACC,aAAA;EArLA;EAwLD;IACC,eAAA;EAtLA;AACF;AA2LA;EACC,oCAAA;EACA,YAAA;AAzLD;;AA4LA;EACC,oCAAA;EACA,gCAAA;EACA,uBAAA;AAzLD;;AA4LA;EACC,wBAAA;EACA,kCAAA;EACA,2BAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AAzLD;;AA4LA;EACC,YAAA;EACA,2BAAA;EACA,YAAA;EACA,qCAAA;AAzLD;;AA4LA;EACC,YAAA;EACA,iBAAA;EAKA,cAAA;AA7LD;;AAgMA;EACC,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AA7LD;;AAgMA;EACC,oCAAA;EACA,gCAAA;EACA,iCAAA;AA7LD;;AAgMA;EACC,iCAAA;AA7LD;;AAgMA;EACC,eAAA;EACA,eAAA;AA7LD;;AAgMA;EACC,uBAAA;EACA,YAAA;AA7LD;;AAgMA;EACC,eAAA;EACA,kBAAA;EACA,iCAAA;EACA,YAAA;EACA,YAAA;AA7LD;AA+LC;EACC,+BAAA;AA7LF;;AAiMA;EACC,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;EAEA,aAAA;EACA,aAAA;AA/LD;AAiMC;EACC,eAAA;AA/LF;;AAiNA;EACC,mBAAA;AA9MD;;AAkNC;EACC,WAAA;AA/MF;;AAmNA;EACC,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EAEA,qBAAA;AAjND;;AAmNA;EACC,yBAAA;AAhND;AAkNC;EACC,yBAAA;AAhNF;;AAoNA;EACC,sBAAA;AAjND;;AAoNA;EACC,eAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;AAjND;;AAoNA;EACC,+BAAA;AAjND;;AAoNA;EACC,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,0BAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;AAjND;AAmNC;EACC,cAAA;EACA,qBAAA;AAjNF;AAqNG;EACC,aAAA;EAEA,YAAA;AApNJ;AA8NE;EACC,iBAAA;EACA,UAAA;EACA,YAAA;AA5NH;;AAoOA;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;AAjOD;;AAoOA,yBAAA;AACA;;;;;;;;;;;;;;;;;;EAkBC,2BAAA;EACA,mCAAA;AAjOD;;AAoOA;;;;;;EAOC,aAAA;AAjOD;;AAoOA;EACC,iCAAA;EACA,iCAAA;AAjOD","sourcesContent":["@import './_App.variables.scss';\n*,\n*::before,\n*::after {\n\tbox-sizing: border-box;\n}\n\n* {\n\tmargin: 0;\n\tpadding: 0;\n\tfont-family: 'Clans Pro', sans-serif;\n\t-ms-text-size-adjust: 100%;\n\ttext-size-adjust: 100%;\n\t-webkit-text-size-adjust: 100%;\n}\n\nhtml,\nbody,\n#root {\n\theight: 100%;\n\tmargin: 0;\n\tpadding: 0;\n}\n\nbody {\n\t-webkit-font-smoothing: antialiased;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n\tfont: inherit;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\toverflow-wrap: break-word;\n}\n\n// Variables\n$color-primary: #333333;\n$text-primary: #fff;\n\n#root,\n#__next {\n\tisolation: isolate;\n}\n\na {\n\ttext-decoration: none;\n\tcolor: black;\n}\n\nbutton {\n\tcursor: pointer;\n\toutline: none;\n}\n\n.btn_solid_bg {\n\tborder: 1px solid $color-primary;\n\tbackground: $color-primary;\n\tcolor: #000;\n\tcolor: $text-primary;\n\tborder-radius: 5px;\n\twidth: 100%;\n\tmargin-bottom: 10px;\n\tpadding: 9.5px 14px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tposition: relative;\n\n\t&.grey {\n\t\tcolor: #333333;\n\t\tbackground: #f2f2f2;\n\t\tborder: 1px solid #f2f2f2;\n\t}\n\n\t&.grey_inverted {\n\t\tcolor: #000;\n\t\tbackground: #fff;\n\t\tborder: 1px solid #bdbdbd;\n\t}\n}\n\n.btn.outline {\n\tborder: 1px solid #4f4f4f;\n}\n\n.btn_solid_bg_inverted {\n\tborder: 1px solid $color-primary;\n\tcolor: $color-primary;\n\tbackground: transparent;\n\tborder-radius: 5px;\n\tmargin-bottom: 10px;\n\tpadding: 9.5px 14px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.ui.disabled.dropdown,\n.ui.dropdown .menu > .disabled.item {\n\tbackground: #f2f2f2 !important;\n\tborder: 1px solid #bdbdbd;\n}\n\n.ui.form .field .ui.disabled.dropdown .text {\n\tcolor: #828282;\n}\n\n.ui.inverted.form .label {\n\tcolor: #000 !important;\n\tfont-weight: 500;\n}\n\n.ui.items:last-child {\n\tmargin: 0px;\n}\n\n.text-error {\n\tcolor: rgb(201, 15, 15);\n\tfont-size: 12px;\n}\n\n.form-control:focus {\n\tcolor: #212529;\n\tbackground-color: #fff;\n\tborder-color: rgb(58, 57, 57);\n\toutline: 0;\n\tbox-shadow: none;\n}\n\n.text-small {\n\tfont-size: 10px;\n}\n\n.filterSearch {\n\tbackground: #f1f1f1;\n\twidth: 255px !important;\n}\n\n.has-search .form-control {\n\tpadding-left: 2.375rem;\n}\n\n.has-search .form-control-feedback {\n\tposition: absolute;\n\twidth: 2.375rem;\n\theight: -0.625rem;\n\tline-height: 2.4rem;\n\ttext-align: center;\n\tpointer-events: none;\n\tcolor: #aaa;\n}\n\n.bidRequestId {\n\tfont-size: 10px;\n}\n\n.action-btn {\n\tborder: 1px solid black;\n}\n\n.action-btn:hover {\n\tborder: 1px solid black;\n\tbackground-color: $color-primary;\n}\n\n.top-panel {\n\t// margin-top: 20px;\n\tborder-top: 1px solid black;\n\tborder-bottom: 1px solid black;\n\tpadding: 15px;\n}\n\n.page-title {\n\tfont-size: 16px;\n\tfont-weight: 450;\n}\n\n.add-driver-form {\n\twidth: 95%;\n\tpadding: 20px;\n}\n\n.add-bank-form {\n\twidth: 95%;\n\tpadding: 20px;\n}\n\nlabel {\n\tfont-weight: bold;\n\tfont-size: 13px;\n}\n\n.col-gap-20 {\n\tcolumn-gap: 20px;\n}\n\n.col-gap-10 {\n\tcolumn-gap: 10px;\n}\n\nselect.form-control {\n\t-webkit-appearance: menulist;\n\t// appearance: none;\n\t// -webkit-appearance: none;\n\t// -moz-appearance: none;\n}\n\n.add-driver-form .form-control {\n\tpadding: 10px;\n}\n\n.add-bank-form .form-control {\n\tpadding: 10px;\n}\n\n.theme-btn {\n\tbackground-color: #bfe635;\n\tbackground-color: $color-primary;\n\tcolor: black;\n\tcolor: $text-primary;\n}\n\n.theme-btn:focus {\n\tbackground-color: $color-primary;\n\tborder-color: $color-primary;\n\tcolor: black;\n\tcolor: $text-primary;\n}\n\n.theme-btn:disabled {\n\tbackground-color: $color-primary;\n\tborder-color: $color-primary;\n\tcolor: black;\n\tcolor: $text-primary;\n}\n\n.theme-btn:hover {\n\tbackground-color: #c9f03e;\n\tbackground-color: $color-primary;\n\tcolor: black;\n\tcolor: $text-primary;\n\tborder-color: $color-primary;\n}\n\n.upload-bol-btn {\n\tmargin-right: 14px;\n}\n\n// .no-auth {\n.dialogue {\n\tposition: fixed;\n\tz-index: 1;\n\ttop: 64px;\n\t// left: 417px;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: auto;\n\tbackground-color: rgba(0, 0, 0, 0.301);\n}\n\n.dialogue-content {\n\tmin-width: 100%;\n\t// display: flex;\n\t// justify-content: center;\n}\n\n.dialogue-form {\n\tposition: fixed;\n\tpadding: 30px;\n\tbackground-color: $text-primary;\n\twidth: 390px;\n\tleft: 53%;\n\ttop: 28%;\n\tbox-shadow: 1px 1px 10px 4px rgba(59, 55, 55, 0.493);\n}\n\n.dialogue-title {\n\tfont-weight: 500;\n\tfont-size: 20px;\n}\n\n.dialogue .form-control {\n\tpadding: 10px;\n}\n\n.dialogue-close {\n\tfont-size: 16px;\n\tcursor: pointer;\n}\n\n// }\n\n.success-dialogue-form {\n\tposition: fixed;\n\tpadding: 30px;\n\tbackground-color: #d4fb41;\n\twidth: 390px;\n\tleft: 51%;\n\ttop: 38%;\n\tbox-shadow: 1px 1px 10px 4px rgba(59, 55, 55, 0.493);\n}\n\n.cursor-pointer {\n\tcursor: pointer;\n}\n\n// [data-column-id=\"5\"] {\n\n//     display: flex !important;\n//     justify-content: left !important;\n\n// }\n\n.auth-form .text-error {\n\tcolor: rgb(243, 124, 124);\n}\n\n.otpbox {\n\tfont-size: 30px;\n\tjustify-content: center !important;\n}\n\n.otpbox input {\n\tmargin: 8px;\n}\n\n.payment_info {\n\twidth: 450px;\n\tjustify-content: center;\n\tmargin: 0 auto;\n}\n\n.ui.radio label {\n\tcursor: auto;\n\tposition: relative;\n\tpadding-left: 10px;\n\toutline: 0;\n\tfont-size: 1em;\n}\n\n.location-component {\n\tpadding: 17px 20px;\n\tborder: 1px solid lightgrey;\n\tborder-radius: 5px;\n\n\t.title {\n\t\tfont-weight: 500;\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t}\n\n\t.detail {\n\t\tmargin-top: 9px;\n\t}\n}\n\n.btn_solid_bg:hover {\n\tbackground-color: $color-primary;\n\tcolor: black;\n\tcolor: $text-primary;\n}\n\n.forget-password-otp input {\n\twidth: 20px !important;\n}\n\n.pass-eye-icon {\n\tfloat: right;\n\tmargin-right: 8px;\n\tfont-size: 18px;\n\tmargin-top: -30px;\n\tposition: relative;\n\tz-index: 2;\n\tcursor: pointer;\n}\n\n.action-icon {\n\tcolumn-gap: 10px;\n\tfont-size: 15px;\n}\n\n.main-logo {\n\theight: 30px;\n\tcolumn-gap: 14px;\n}\n\n.company-name {\n\tcolor: grey;\n\tfont-size: 20px;\n\tmargin-top: auto;\n}\n\n// -------------- Track Order ------------------------\n\n.track-order {\n\tpadding: 20px 40px 0 20px;\n}\n\n// ---------------------------------------\n\n.forgot-password-otp input {\n\tcolor: #000 !important;\n\tpadding: 0 !important;\n}\n\n.forgot-password-otp {\n\tfont-size: 35px;\n\tjustify-content: center !important;\n}\n\n.forgot-password-otp input {\n\tmargin-right: 25px;\n}\n\n.bol .nav-link {\n\tcolor: gray;\n\tfont-size: 16px;\n}\n\n.bol .nav-link.active {\n\tcolor: black;\n\tfont-weight: 500;\n}\n\n.bol-action-icon {\n\tmargin-right: 8px;\n}\n\n.account-settings {\n\t.account-settings-menu {\n\t\tpadding-left: 30px;\n\t}\n\n\th3 {\n\t\tpadding: 18px 30px 2px 30px;\n\t}\n\n\t.menu-item {\n\t\tpadding: 18px 18px 18px 0;\n\t}\n\n\t.menu-title {\n\t\t// margin: auto;\n\t\tfont-size: 16px;\n\t}\n}\n\n.sweet-loading {\n\tposition: fixed;\n\tcolor: black;\n\tz-index: 10000;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: #2b222252;\n\tjustify-content: center;\n}\n\n.order-confirmed-label {\n\twidth: 4px;\n\tposition: absolute;\n\tleft: -1px;\n\ttop: 0;\n\theight: 100%;\n\tbackground: #3cb931;\n}\n\n.new-bid-request-label {\n\twidth: 4px;\n\tposition: absolute;\n\tleft: -1px;\n\ttop: 0;\n\theight: 100%;\n\tbackground: #2248c5;\n}\n\n.bid-awarded-label {\n\twidth: 4px;\n\tposition: absolute;\n\tleft: -1px;\n\ttop: 0;\n\theight: 100%;\n\tbackground: #c3f157;\n}\n\n.other-label {\n\twidth: 4px;\n\tposition: absolute;\n\tleft: -1px;\n\ttop: 0;\n\theight: 100%;\n\tbackground: rgb(187, 182, 182);\n}\n\n.notification-action-icon {\n\tfont-size: 18px;\n}\n\n.notification-action-icon .fa:hover {\n\ttext-shadow: 0px 2px 10px rgb(179, 176, 176);\n}\n\n.additional_links .active {\n\tborder-bottom: 2px solid #c3f157;\n\tpadding-bottom: 3px;\n}\n\n.invite-code-info {\n\tmargin: 30px;\n\n\t.invite-code-block {\n\t\tpadding: 30px;\n\t\tbackground-color: rgb(235, 235, 235);\n\t}\n\n\t.title {\n\t\tfont-size: 18px;\n\t}\n\n\t.invite-code {\n\t\tfont-size: 20px;\n\t\tfont-weight: 500;\n\t}\n\n\t.invite-code-form {\n\t\tmargin-top: 20px;\n\t}\n}\n\n// .sc-fLlhyt.ifOHjV {\n//     /* position: relative; */\n//     width: auto !important;\n//     display: table;\n// }\n\n.theme-text {\n\tcolor: #d4fb41;\n}\n\n.password_eye_icon {\n\tposition: absolute;\n\ttop: 0;\n\tright: 5px;\n\tline-height: 1.15;\n\tmargin: inherit;\n\tcursor: pointer;\n}\n\n.ui.loading.button {\n\tdisplay: none;\n}\n\n.btn_solid_bg {\n\t.signin {\n\t\tdisplay: inline-block !important;\n\t\tbackground: transparent !important;\n\t\ttext-align: right;\n\t\tposition: absolute !important;\n\t\tright: 0;\n\t}\n}\n\n.signin_form {\n\twidth: 340px;\n\tmargin-top: 100px !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tmargin: 0 auto;\n\n\t.description {\n\t\tfont-weight: 400;\n\t\tfont-size: 32px;\n\t\tline-height: 51px;\n\t\tcolor: #ffffff;\n\t\tmargin-bottom: 20px;\n\t\ttext-wrap: balance;\n\t}\n\n\t.btn_wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t.text-error {\n\t\tcolor: rgb(255, 97, 97) !important;\n\t}\n}\n\n.signin_form {\n\t.heading {\n\t\tfont-weight: 500;\n\t\tfont-size: 32px;\n\t\tline-height: 41px;\n\t\tcolor: #ffffff;\n\t\tmargin-bottom: 30px;\n\t}\n\n\t.heading_m {\n\t\tfont-weight: 500;\n\t\tfont-size: 22px;\n\t\tline-height: 28px;\n\t\tcolor: #ffffff;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.heading_s {\n\t\tfont-weight: 500;\n\t\tfont-size: 18px;\n\t\tline-height: 23px;\n\t\tcolor: #ffffff;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.input_wrapper {\n\t\tlabel {\n\t\t\tcolor: #fff;\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\n\t\t.input {\n\t\t\tflex-direction: column;\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 14px;\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n\n\tinput {\n\t\tpadding: 9.5px 14px !important;\n\t}\n\n\t.forgot_password {\n\t\tfont-weight: 500;\n\t\tfont-size: 18px;\n\t\ttext-align: right;\n\t\tcolor: #ffffff;\n\t}\n\n\tbutton {\n\t\tmargin: 20px 0;\n\t}\n}\n\ninput[type='text'],\ninput[type='password'],\ninput[type='password'],\ninput[type='select'],\noption {\n\ttext-transform: none;\n}\n\n.ui.inverted.segment,\n.ui.primary.inverted.segment {\n\tbackground: transparent !important;\n}\n\n.card {\n\tbackground: #fff;\n\ttransition: 0.5s;\n\tborder: 0;\n\tmargin-bottom: 30px;\n\tborder-radius: 0.55rem;\n\tposition: relative;\n\twidth: 100%;\n\t// box-shadow: 0 1px 2px 0 rgb(0 0 0 / 10%);\n}\n\n.chat-app .people-list {\n\twidth: 280px;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tpadding: 20px;\n\tz-index: 7;\n}\n\n.people-list {\n\t-moz-transition: 0.5s;\n\t-o-transition: 0.5s;\n\t-webkit-transition: 0.5s;\n\ttransition: 0.5s;\n}\n\n.people-list .chat-list li {\n\tpadding: 10px 15px;\n\tlist-style: none;\n\tborder-radius: 3px;\n}\n\n.people-list .chat-list li:hover {\n\tbackground: #efefef;\n\tcursor: pointer;\n}\n\n.people-list .chat-list li.active {\n\tbackground: #efefef;\n}\n\n.people-list .chat-list li .name {\n\tfont-size: 15px;\n}\n\n.people-list .chat-list img {\n\twidth: 45px;\n\tborder-radius: 50%;\n}\n\n.people-list img {\n\tfloat: left;\n\tborder-radius: 50%;\n}\n\n.people-list .about {\n\tfloat: left;\n\tpadding-left: 8px;\n}\n\n.people-list .status {\n\tcolor: #999;\n\tfont-size: 13px;\n}\n\n.chat .chat-header {\n\tpadding: 15px 20px;\n\tborder-bottom: 2px solid #f4f7f6;\n}\n\n.chat .chat-header img {\n\tfloat: left;\n\tborder-radius: 40px;\n\twidth: 40px;\n}\n\n.chat .chat-header .chat-about {\n\tfloat: left;\n\tpadding-left: 10px;\n}\n\n.chat .chat-history {\n\tpadding: 20px;\n\tborder-bottom: 2px solid #fff;\n\t// height: 380px;\n}\n\n.chat .chat-history ul {\n\tpadding: 0;\n}\n\n.chat .chat-history ul li {\n\tlist-style: none;\n\tmargin-bottom: 15px;\n}\n\n.chat .chat-history ul li:last-child {\n\tmargin-bottom: 0px;\n}\n\n.chat .chat-history .message-data {\n\tmargin-bottom: 8px;\n}\n\n.chat .chat-history .message-data img {\n\tborder-radius: 40px;\n\twidth: 40px;\n}\n\n.chat .chat-history .message-data-time {\n\tcolor: #434651;\n\tpadding-left: 6px;\n\tfont-size: 10px;\n}\n\n.chat .chat-history .message {\n\tcolor: #444;\n\tpadding: 10px 12px;\n\tline-height: 26px;\n\t// font-size: 16px;\n\tborder-radius: 7px;\n\tdisplay: inline-block;\n\tposition: relative;\n\tmax-width: 60%;\n}\n\n.chat .chat-history .message:after {\n\tbottom: 100%;\n\t// left: 10px;\n\tborder: solid transparent;\n\tcontent: ' ';\n\theight: 0;\n\twidth: 0;\n\tposition: absolute;\n\tpointer-events: none;\n\tborder-bottom-color: #fff;\n\tborder-width: 10px;\n\tmargin-left: -10px;\n}\n\n.chat .chat-history .my-message {\n\tbackground: #efefef;\n}\n\n.chat .chat-history .my-message:after {\n\tbottom: 100%;\n\tleft: 25px;\n\tborder: solid transparent;\n\tcontent: ' ';\n\theight: 0;\n\twidth: 0;\n\tposition: absolute;\n\tpointer-events: none;\n\tborder-bottom-color: #efefef;\n\tborder-width: 10px;\n\t// margin-left: -10px\n}\n\n.chat .chat-history .other-message {\n\tbackground: #e8f1f3;\n\ttext-align: right;\n}\n\n.chat .chat-history .other-message:after {\n\tborder-bottom-color: #e8f1f3;\n\t// left: 200px\n\tright: 10px;\n}\n\n.chat .chat-message {\n\tpadding: 20px;\n}\n\n.online,\n.offline,\n.me {\n\tmargin-right: 2px;\n\tfont-size: 8px;\n\tvertical-align: middle;\n}\n\n.online {\n\tcolor: #86c541;\n}\n\n.offline {\n\tcolor: #e47297;\n}\n\n.me {\n\tcolor: #1d8ecd;\n}\n\n.float-right {\n\tfloat: right;\n}\n\n.clearfix:after {\n\tvisibility: hidden;\n\tdisplay: block;\n\tfont-size: 0;\n\tcontent: ' ';\n\tclear: both;\n\theight: 0;\n}\n\n@media only screen and (max-width: 767px) {\n\t.chat-app .people-list {\n\t\theight: 465px;\n\t\twidth: 100%;\n\t\toverflow-x: auto;\n\t\tbackground: #fff;\n\t\tleft: -400px;\n\t\tdisplay: none;\n\t}\n\n\t.chat-app .people-list.open {\n\t\tleft: 0;\n\t}\n\n\t.chat-app .chat {\n\t\tmargin: 0;\n\t}\n\n\t.chat-app .chat .chat-header {\n\t\tborder-radius: 0.55rem 0.55rem 0 0;\n\t}\n\n\t.chat-app .chat-history {\n\t\theight: 300px;\n\t\toverflow-x: auto;\n\t}\n}\n\n.chat-app .chat-list {\n\theight: 480px;\n\toverflow-x: auto;\n}\n\n.chat-app .chat-history {\n\theight: 380px;\n\toverflow-x: auto;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 992px) {\n\t.chat-app .chat-list {\n\t\theight: 480px;\n\t\toverflow-x: auto;\n\t}\n\n\t.chat-app .chat-history {\n\t\theight: 600px;\n\t\toverflow-x: auto;\n\t}\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {\n\t.chat-app .chat-list {\n\t\theight: 480px;\n\t\toverflow-x: auto;\n\t}\n\n\t.chat-app .chat-history {\n\t\theight: calc(100vh - 350px);\n\t\toverflow-x: auto;\n\t}\n}\n\n.fa-send {\n\theight: 21px;\n}\n\n.password_eye_icon_signup {\n\tposition: absolute;\n\ttop: 0;\n\tright: 5px;\n\tline-height: 1.15;\n\tmargin: auto;\n\tcursor: pointer;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.ui.loading.button {\n\tdisplay: none;\n}\n\n.btn_solid_bg {\n\t.signin {\n\t\tdisplay: inline-block !important;\n\t\tbackground: transparent !important;\n\t\ttext-align: right;\n\t\tposition: absolute !important;\n\t\tright: 0;\n\t}\n}\n\n.signup_form {\n\twidth: 340px;\n\t// height: 100vh;\n\tmargin-top: 30px !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tmargin: 0 auto;\n\n\t.description {\n\t\tfont-weight: 400;\n\t\tfont-size: 32px;\n\t\tline-height: 51px;\n\t\tcolor: #ffffff;\n\t\tmargin-bottom: 20px;\n\t\ttext-wrap: balance;\n\t}\n\n\t.btn_wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t.heading {\n\t\tfont-weight: 500;\n\t\tfont-size: 32px;\n\t\tline-height: 41px;\n\t\tcolor: #ffffff;\n\t\tmargin-bottom: 30px;\n\t}\n\n\t.heading_m {\n\t\tfont-weight: 500;\n\t\tfont-size: 22px;\n\t\tline-height: 28px;\n\t\tcolor: #ffffff;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.heading_s {\n\t\tfont-weight: 500;\n\t\tfont-size: 18px;\n\t\tline-height: 23px;\n\t\tcolor: #ffffff;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.input_wrapper {\n\t\tlabel {\n\t\t\tcolor: #fff;\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\n\t\t.input {\n\t\t\tflex-direction: column;\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 14px;\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n\n\tinput {\n\t\tpadding: 9.5px 14px !important;\n\t}\n\n\t.forgot_password {\n\t\tfont-weight: 500;\n\t\tfont-size: 18px;\n\t\ttext-align: right;\n\t\tcolor: #ffffff;\n\t}\n\n\tbutton {\n\t\tmargin: 20px 0;\n\t}\n\n\t.heading {\n\t\tmargin-bottom: 10px;\n\t}\n\n\twidth: 700px;\n}\n\n.form_info {\n\tfont-weight: 400;\n\tfont-size: 15px;\n\ttext-align: justify;\n\tcolor: #d4fb41;\n\n\tspan {\n\t\ttext-decoration: underline;\n\t}\n}\n\n.pdf {\n\theight: inherit;\n}\n\n@keyframes slideUp {\n\tfrom {\n\t\ttransform: translateY(100vh);\n\t}\n\n\tto {\n\t\ttransform: translateY(0);\n\t}\n}\n\n.bubbleContainer {\n\twidth: 80%;\n\tdisplay: flex;\n\tpadding: 10px 20px;\n\tanimation: slideUp 0.5s ease-in-out;\n}\n\n.close {\n\tfont-size: 16px;\n}\n\n.google-map {\n\theight: 400px;\n\n\t.google-map-marker {\n\t\tcolor: rgb(184, 184, 184);\n\t\tfont-size: 40px;\n\t\tposition: relative;\n\t\tbottom: 38px;\n\t\tright: 10px;\n\t}\n}\n\n.auto-pricing,\n.freight-charges {\n\t.row > * {\n\t\tpadding-left: 0 !important;\n\t}\n\n\t.form-control {\n\t\theight: 42px;\n\t\tfont-size: 13px;\n\t\tcursor: pointer;\n\t}\n\n\t.title {\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t}\n\n\t.add-icon {\n\t\theight: 42px;\n\t\tdisplay: flex;\n\t\tcursor: pointer;\n\t}\n\n\t.add-icon i {\n\t\tfont-size: 30px;\n\t\talign-self: flex-end;\n\t}\n\n\t.price-action-btn {\n\t\tmin-height: 42px;\n\t\tmin-width: 42px;\n\t}\n\n\t.price-rows {\n\t\tmin-height: 50vh;\n\t}\n\n\t.not-available {\n\t\theight: 42px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t}\n}\n\n.bg-grey {\n\tbackground-color: #f3f3f3;\n}\n\n.driver-details {\n\tbackground-color: rgb(228, 228, 228);\n\tborder-radius: 5px;\n\tpadding: 24px 0;\n\tmargin: 0 20px;\n}\n\n.bold {\n\tfont-weight: 500;\n}\n\n// .custom-tooltip {\n//     position: relative;\n// }\n\n// .custom-tooltip:hover::after {\n//     content: attr(data-title);\n//     background-color: black;\n//     padding: 8px;\n//     // color: black;\n//     border-radius: 3px;\n//     // font-size: 12px;\n//     line-height: 14px;\n//     display: block;\n//     position: absolute;\n//     // top: 100%;\n//     // left: 50%;\n//     transform: translateX(-80%);\n//     white-space: nowrap;\n//     z-index: 1;\n// }\n\n.sc-hLBbgP {\n\tpadding-left: 10px !important;\n\tpadding-right: 10px !important;\n}\n\n.sc-eDWCr {\n\ttext-overflow: unset !important;\n}\n\n.lnndaO {\n\twhite-space: pre-line !important;\n}\n\n.text-theme {\n\tcolor: #b8df2c;\n}\n\n.bg-pending {\n\tbackground-color: #f2c94c;\n\tcolor: black;\n}\n\n.badge {\n\tpadding: 5px;\n\tletter-spacing: 2px;\n}\n\n.ls-1 {\n\tletter-spacing: 1px;\n}\n\n.text-green {\n\tcolor: #21611c;\n}\n\n.btn-danger {\n\tbackground-color: rgba(190, 33, 33, 0.87);\n}\n\n.btn-secondary {\n\tcolor: #000;\n\tbackground-color: rgb(231, 231, 231);\n\tborder-color: rgb(192, 192, 192);\n}\n\n.btn-secondary:hover {\n\tcolor: #000;\n\tbackground-color: rgb(206, 206, 206);\n\tborder-color: rgb(192, 192, 192);\n}\n\n.notification-icon {\n\t.badge {\n\t\tposition: relative;\n\t\ttop: -10px;\n\t\tleft: -14px;\n\t\tfont-size: 9px;\n\t\t// border-radius: 50%;\n\t\tletter-spacing: 0;\n\t}\n\n\ti {\n\t\tfont-size: 20px !important;\n\t}\n}\n\n.auth {\n\t.modal {\n\t\tbackground-color: rgba(92, 92, 92, 0.123);\n\t}\n\n\t.modal-content {\n\t\tpadding: 30px;\n\t\tbackground-color: #daff56;\n\t\tborder: 1px solid lightgrey;\n\t\tbox-shadow: 1px 1px 10px 4px rgba(59, 55, 55, 0.363);\n\t}\n}\n\n// .form-control::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n//     color: rgb(255, 40, 40);\n//     opacity: 1; /* Firefox */\n// }\n\n.otpbox input {\n\tpadding: 0 !important;\n}\n\n.dwolla-main {\n\t.dwolla-submit input[type='submit'] {\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\twidth: 120px;\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 0px;\n\t\tpadding: 10px 20px;\n\t\tborder-radius: 3px;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\ttext-align: center;\n\t\ttext-decoration: none;\n\t\tcolor: #fff;\n\t\tbackground-color: #202033;\n\t\tbox-shadow: 0px 1px 0px rgba(22, 29, 37, 0.1),\n\t\t\tinset 0px 1px 0px 1px rgba(255, 255, 255, 0.06);\n\t}\n\n\t.dwolla-customer-input {\n\t\tborder: 1px solid #c9d3e0;\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\ttransition: box-shadow 0.5s, background-color 0.5s, border 0.5s;\n\t\tborder-radius: 3px;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\ttext-align: left;\n\t\ttext-decoration: none;\n\t\tbackground-color: #fff;\n\t\tcolor: #5e4e76;\n\t}\n\n\t.dwolla-width-1 {\n\t\twidth: 470px;\n\t}\n\n\t.dwolla-width-1 input[type='text'] {\n\t\tpadding: 10px 0px 10px 15px;\n\t\twidth: 455px;\n\t}\n\n\t.dwolla-width-2 {\n\t\twidth: 228px;\n\t}\n\n\t.dwolla-width-2 input[type='text'] {\n\t\tpadding: 10px 0px 10px 15px;\n\t\twidth: 213px;\n\t}\n\n\t.dwolla-width-3 {\n\t\twidth: 147px;\n\t}\n\n\t.dwolla-width-3 input[type='text'] {\n\t\tpadding: 10px 0px 10px 15px;\n\t\twidth: 133px;\n\t}\n\n\t::placeholder {\n\t\tcolor: #52627b;\n\t\topacity: 1;\n\t}\n\n\t:-ms-input-placeholder {\n\t\tcolor: #52627b;\n\t}\n\n\t::-ms-input-placeholder {\n\t\tcolor: #52627b;\n\t}\n\n\t.dwolla-customer-input[type='text']:disabled {\n\t\tbackground: #dddddd;\n\t\tcursor: default;\n\t}\n\n\t#dwolla-success {\n\t\tbackground-color: #ddf0e0;\n\t\tcolor: #354153;\n\t\ttext-align: center;\n\t\tpadding: 10px;\n\t\tborder-radius: 3px;\n\t\tborder-color: #58b467;\n\t\tborder-style: solid;\n\t\tborder-width: 1px;\n\t}\n\n\t#dwolla-info {\n\t\tbackground: rgba(54, 136, 207, 0.15);\n\t\tcolor: #354153;\n\t\ttext-align: center;\n\t\tpadding: 10px;\n\t\tborder-radius: 3px;\n\t\tborder: 1px solid rgba(54, 136, 207, 0.5);\n\t}\n\n\t#dwolla-error {\n\t\tbackground-color: #f7ebee;\n\t\tcolor: #354153;\n\t\ttext-align: center;\n\t\tpadding: 10px;\n\t\tborder-radius: 3px;\n\t\tborder-color: #cf5473;\n\t\tborder-style: solid;\n\t\tborder-width: 1px;\n\t}\n\n\t.dwolla-link {\n\t\tcolor: #1d6cd1;\n\t}\n\n\t.dwolla-customer-tos {\n\t\twidth: 100%;\n\t\theight: 80px;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tmargin-top: 20px;\n\t}\n\n\t.dwolla-customer-checkbox {\n\t\twidth: 5%;\n\t\theight: 80px;\n\t\tdisplay: inline;\n\t\tfloat: left;\n\t}\n\n\t.dwolla-customer-text {\n\t\twidth: 91%;\n\t\theight: 80px;\n\t\tdisplay: inline;\n\t\tfloat: left;\n\t\tmargin-left: 10px;\n\t}\n\n\t.dwolla-input-container {\n\t\tdisplay: inline-block;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t\tmargin-top: 10px;\n\t\tpadding: 0px 0px;\n\t}\n\n\t.dwolla-input-container label {\n\t\ttext-align: left;\n\t\tdisplay: block;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n\n\t.dwolla-loading {\n\t\tbackground-color: #5e4e76;\n\t\tposition: relative;\n\t\tanimation-name: loading;\n\t\tanimation-duration: 3s;\n\t\tanimation-iteration-count: infinite;\n\t}\n\n\t@keyframes loading {\n\t\t0% {\n\t\t\tbackground-color: #5e4e76;\n\t\t}\n\n\t\t50% {\n\t\t\tbackground-color: #8393aa;\n\t\t}\n\n\t\t100% {\n\t\t\tbackground-color: #5e4e76;\n\t\t}\n\t}\n\n\t.dwolla-document-submit input[type='submit'] {\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\twidth: 120px;\n\t\tmargin-top: 45px;\n\t\tmargin-bottom: 0px;\n\t\tpadding: 10px 20px;\n\t\ttransition: box-shadow 0.5s, background-color 0.5s, border 0.5s;\n\t\tborder-radius: 3px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: center;\n\t\ttext-decoration: none;\n\t\tcolor: #fff;\n\t\tbackground-color: #5e4e76;\n\t}\n\n\t.dwolla-submit input[type='submit'] {\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\twidth: 120px;\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 0px;\n\t\tpadding: 10px 20px;\n\t\ttransition: box-shadow 0.5s, background-color 0.5s, border 0.5s;\n\t\tborder-radius: 5px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: center;\n\t\ttext-decoration: none;\n\t\tcolor: #fff;\n\t\tbackground-color: #5e4e76;\n\t}\n\n\t.dwolla-document-choose input[type='file'] {\n\t\tdisplay: none;\n\t}\n\n\t.dwolla-document-type {\n\t\tborder: 0;\n\t\tfloat: left;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 0px;\n\t\tpadding: 10px 10px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t}\n\n\t.dwolla-document-type select {\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t\tfloat: left;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 0px;\n\t\tpadding: 10px 20px;\n\t\ttransition: box-shadow 0.5s, background-color 0.5s, border 0.5s;\n\t\tborder-radius: 5px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: center;\n\t\tcolor: #5e4e76;\n\t\tbackground-color: #fff;\n\t\tbox-shadow: 0 2px 4px 0 rgba(53, 65, 83, 0.12),\n\t\t\t0 0 2px 0 rgba(53, 65, 83, 0.12);\n\t}\n\n\t.dwolla-document-type label {\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t\tfloat: left;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 0px;\n\t\tfont-size: 12px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: left;\n\t\tcolor: #5e4e76;\n\t}\n\n\t.dwolla-document-name-display {\n\t\ttext-align: center;\n\t\tpadding: 5px;\n\t\tborder: 1px solid #c9d3e0;\n\t\twidth: 314px;\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\tmargin-top: 25px;\n\t\tmargin-bottom: 0px;\n\t\tmargin-right: 0px;\n\t\tpadding: 10px 20px;\n\t\tborder-radius: 3px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: left;\n\t\tcolor: #354153;\n\t\tbackground-color: #fff;\n\t\tbox-shadow: 0px 1px 0px rgba(22, 29, 37, 0.05);\n\t}\n\n\t.hide-class {\n\t\tdisplay: none;\n\t}\n\n\t.dwolla-span-container {\n\t\tdisplay: inline-block;\n\t\twidth: 320px;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t\tmargin-top: 10px;\n\t\tpadding: 0px 0px;\n\t}\n\n\t.dwolla-span-container label {\n\t\ttext-align: center;\n\t\tdisplay: block;\n\t\tfont-size: 10px;\n\t}\n\n\t.dwolla-document-submit input[type='submit'] {\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\twidth: 470px;\n\t\tmargin-top: 20px;\n\t\tmargin-bottom: 0px;\n\t\tpadding: 10px 20px;\n\t\tbackground: #202033;\n\t\tbox-shadow: 0px 1px 0px rgba(22, 29, 37, 0.1),\n\t\t\tinset 0px 1px 0px 1px rgba(255, 255, 255, 0.06);\n\t\tborder-radius: 3px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: center;\n\t\ttext-decoration: none;\n\t\tcolor: #fff;\n\t}\n\n\t.dwolla-submit input[type='submit'] {\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\twidth: 470px;\n\t\tmargin-top: 20px;\n\t\tmargin-bottom: 0px;\n\t\tpadding: 10px 20px;\n\t\tbackground: #202033;\n\t\tbox-shadow: 0px 1px 0px rgba(22, 29, 37, 0.1),\n\t\t\tinset 0px 1px 0px 1px rgba(255, 255, 255, 0.06);\n\t\tborder-radius: 3px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: center;\n\t\ttext-decoration: none;\n\t\tcolor: #fff;\n\t}\n\n\t.dwolla-document-choose input[type='file'] {\n\t\tdisplay: none;\n\t}\n\n\t.dwolla-file-name {\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 0px;\n\t\theight: 40px;\n\t\twidth: 470px;\n\t}\n\n\t.dwolla-document-label {\n\t\ttext-align: left;\n\t\tdisplay: inline-block;\n\t\twidth: 470px;\n\t}\n\n\t.dwolla-document-chooser {\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 0px;\n\t\tmargin-left: -5px;\n\t\tpadding: 10px 20px;\n\t\tbox-shadow: 0px 1px 0px rgba(22, 29, 37, 0.05);\n\t\tborder-radius: 3px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: center;\n\t\ttext-decoration: none;\n\t\tcolor: #354153;\n\t\tbackground: rgba(201, 211, 224, 0.6);\n\t\tborder: 1px solid #c9d3e0;\n\t}\n\n\t.dwolla-document-type {\n\t\tborder: 0;\n\t\tfloat: left;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 20px;\n\t\tpadding: 10px 0px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: left;\n\t}\n\n\t.dwolla-document-type select {\n\t\tborder: 1px solid #c9d3e0;\n\t\twidth: 470px;\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 0px;\n\t\tpadding: 10px 20px;\n\t\tborder-radius: 3px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\ttext-align: left;\n\t\tcolor: #354153;\n\t\tbackground-color: #fff;\n\t\tbox-shadow: 0px 1px 0px rgba(22, 29, 37, 0.05);\n\t}\n\n\t.dwolla-document-type option {\n\t\tfont-weight: 400;\n\t}\n\n\t.dwolla-document-description {\n\t\tcolor: #52627b;\n\t\ttext-align: left;\n\t\tpadding: 5px 0px;\n\t}\n}\n\n@media screen and (max-width: 850px) {\n\t.sidebar_container {\n\t\tdisplay: none;\n\t}\n\n\t.dashboard_rightcontainer {\n\t\tmin-width: 100%;\n\t}\n}\n\n// Dwolla CSS\n\n.dwolla-vcr-submit {\n\tbackground-color: #bfe635 !important;\n\tcolor: black;\n}\n\n.dwolla-vcr-submit:disabled {\n\tbackground-color: #d4fb41 !important;\n\tborder-color: #d4fb41 !important;\n\tcolor: black !important;\n}\n\n.dwolla-content {\n\tdisplay: flex !important;\n\tjustify-content: center !important;\n\tborder: 1px solid lightgrey;\n\tpadding: 10px;\n\twidth: 99%;\n\tbackground-color: #fafafa;\n\tborder-radius: 5px;\n}\n\n.card {\n\tmargin: 10px;\n\tborder: 1px solid lightgrey;\n\theight: 100%;\n\tbox-shadow: 1px 1px 3px 1px lightgrey;\n}\n\n.width_box_lg {\n\twidth: 700px;\n\tmin-height: 100vh;\n\t// display: flex;\n\t// flex-direction: column;\n\t// justify-content: center;\n\t// margin: 55px auto 0 auto;\n\tmargin: 0 auto;\n}\n\n.width_box_sm {\n\twidth: 340px;\n\theight: 100vh;\n\twidth: 400px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin: 0 auto 0 auto;\n}\n\n.form-check-input:checked {\n\tbackground-color: #a4c52e !important;\n\tborder-color: #a4c52e !important;\n\tborder: 1px solid grey !important;\n}\n\n.form-check-input {\n\tborder: 1px solid grey !important;\n}\n\n.table-action-icon {\n\tfont-size: 20px;\n\tcursor: pointer;\n}\n\n.custom-scroll {\n\tscroll-behavior: smooth;\n\theight: 100%;\n}\n\n.taxesAndSurchargestext {\n\tcursor: pointer;\n\tposition: absolute;\n\ttransform: translate(72px, -24px);\n\theight: 14px;\n\twidth: 110px;\n\n\t&.left {\n\t\ttransform: translate(40px, 0px);\n\t}\n}\n\n.taxesAndSurchargesTooltip {\n\tposition: relative;\n\ttext-align: center;\n\tbackground-color: #fff;\n\tvisibility: hidden;\n\ttransform: translate(-460px, -270px);\n\twidth: 590px;\n\tz-index: 100;\n\toverflow-y: auto;\n\tborder-radius: 8px;\n\tbox-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n\n\tpadding: 2rem;\n\theight: 250px;\n\n\t.taxChargesView > :last-child > sub {\n\t\tbottom: 0.05rem;\n\t}\n}\n\n// .taxesAndSurchargesTooltip:before{\n// \tcontent: '';\n// \tposition: absolute;\n// \tbackground-color: #1d6cd1;\n// \twidth: 0;\n// \theight: 0;\n// \tborder-left: 30px solid transparent;\n// \tborder-right: 30px solid transparent;\n// \tborder-top: 30px solid #fff;\n// \ttop: 50px;\n// \tleft: 250px;\n\n// }\n\n.taxesAndSurchargestext:hover .taxesAndSurchargesTooltip {\n\tvisibility: visible;\n}\n\ndiv#date-picker-container {\n\t& > div {\n\t\twidth: 100%;\n\t}\n}\n\n.text-wrap-ellipsis {\n\ttext-overflow: ellipsis;\n\tdisplay: -webkit-box;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\n\t-webkit-line-clamp: 1;\n}\n.text-first-letter-uppercase {\n\ttext-transform: lowercase; // Convert all text to lowercase\n\n\t&::first-letter {\n\t\ttext-transform: uppercase; // Capitalize the first letter\n\t}\n}\n\n.outline1 {\n\toutline: 1px solid red;\n}\n\n.active_td {\n\twidth: 0.625rem;\n\tposition: absolute;\n\tleft: -1px;\n\ttop: 0;\n\theight: 100%;\n\tbackground: #d4fb41;\n}\n\n.text-transform-none {\n\ttext-transform: none !important;\n}\n\n.feedback-direct {\n\tfont-weight: 600;\n\tcolor: rgba(0, 0, 0, 0.87);\n\tcursor: pointer;\n\ttext-decoration: underline;\n\ttransition: text-decoration 0.3s ease;\n\tdisplay: flex;\n\talign-items: center;\n\n\t&:hover {\n\t\tcolor: inherit;\n\t\ttext-decoration: none;\n\n\t\t&:has(> svg) {\n\t\t\t// color: #d4fb41;\n\t\t\t& > svg {\n\t\t\t\tfill: #d4fb41;\n\t\t\t\t// fill: #000;\n\t\t\t\theight: 20px;\n\t\t\t\t// &:hover {\n\t\t\t\t// \tfill: #d4fb41;\n\t\t\t\t// }\n\t\t\t}\n\t\t}\n\t}\n\n\t&:has(> svg) {\n\t\t// color: #1d8ecd;\n\t\t& > svg {\n\t\t\ttranslate: 0 -10%;\n\t\t\tfill: #000;\n\t\t\theight: 20px;\n\t\t\t// &:hover {\n\t\t\t// \tfill: #d4fb41;\n\t\t\t// }\n\t\t}\n\t}\n}\n\n.text-end-center {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: end;\n}\n\n/* Accessibility classes*/\ni.flag:not(.icon),\ni.icon,\n.ui.accordion .accordion .title .dropdown.icon,\n.ui.accordion .title .dropdown.icon,\n.ui.checkbox,\n.ui.selection.dropdown .menu,\n.ui.search.dropdown .menu,\n.ui.scrolling.dropdown .menu,\n.ui.dropdown > .dropdown.icon,\n.ui.visible.popup,\n.ui.rating .icon,\n.ui.shape .side,\n.ui.shape .side *,\n.ui.sidebar,\n.ui.sidebar > *,\n.pushable > .fixed,\n.pushable > .pusher,\n.animating.transition {\n\tbackface-visibility: hidden;\n\t-webkit-backface-visibility: hidden;\n}\n\n.ui.justified.container,\n.ui.grid > .justified.column.column,\n.ui.grid > .justified.row > .column,\n.ui.grid > .row > .justified.column.column,\n.ui.justified.grid > .column,\n.ui.justified.grid > .row > .column {\n\t-webkit-hyphens: auto;\n\thyphens: auto;\n}\n\n.ui.selection.dropdown .menu {\n\t-webkit-overflow-scrolling: touch;\n\t-webkit-overflow-scrolling: touch;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
